import React, { useRef, useEffect } from "react";
import { Check } from "lucide-react";
import { STEPS, DEVANAGARI } from "@/mock/data";
import { useApp } from "@/context/AppContext";

export default function Stepper() {
  const { application, goToStep } = useApp();
  const current = application.currentStep;
  const scrollRef = useRef(null);
  const currentRef = useRef(null);

  useEffect(() => {
    if (currentRef.current) {
      currentRef.current.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }, [current]);

  return (
    <div ref={scrollRef} className="stepper-scroll overflow-x-auto px-3 pb-3">
      <div className="flex min-w-max gap-2">
        {STEPS.map((title, i) => {
          const n = i + 1;
          const completed = n < current;
          const active = n === current;
          const clickable = n <= current;
          return (
            <button
              key={n}
              ref={active ? currentRef : null}
              type="button"
              disabled={!clickable}
              onClick={() => clickable && goToStep(n)}
              className={`relative w-[108px] min-w-[108px] select-none overflow-hidden rounded-2xl border bg-white px-3 pb-2.5 pt-3 text-center transition-all ${
                completed
                  ? "border-[#5a9e3a]/40"
                  : active
                  ? "border-[#E0A106] shadow-[0_4px_14px_rgba(224,161,6,0.25)]"
                  : "border-[#e6dcc4]"
              } ${clickable ? "cursor-pointer hover:-translate-y-0.5" : "cursor-not-allowed opacity-90"}`}
            >
              {/* top accent bar */}
              <span
                className={`absolute inset-x-0 top-0 h-1.5 ${
                  completed ? "bg-[#5a9e3a]" : active ? "bg-[#E0A106]" : "bg-[#eadfc6]"
                }`}
              />
              <span
                className={`mx-auto mb-1.5 flex h-8 w-8 items-center justify-center rounded-xl text-[13px] font-bold ${
                  completed
                    ? "bg-[#5a9e3a] text-white"
                    : active
                    ? "bg-[#E0A106] text-white"
                    : "bg-[#f1ead7] text-[#b3a684]"
                }`}
              >
                {completed ? <Check className="h-4 w-4" strokeWidth={3} /> : DEVANAGARI[n]}
              </span>
              <strong
                className={`block text-[12px] font-semibold leading-tight ${
                  completed || active ? "text-[#1b5e3f]" : "text-[#a89b78]"
                }`}
              >
                {title}
              </strong>
            </button>
          );
        })}
      </div>
    </div>
  );
}
